
import authservice from './authservice'

export default {
  checkAccess(to, from, next) {
    next(
      authservice.checkAccessPath(to,from,next)
    )
  },
  isLoggedIn(to, from, next) {
    next(authservice.isAuthorized() ? {
      path: '/dashboard'
    } : true);
  }
}
